var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoepistumEcourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.39 113.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#24b9a3;}.cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.3,
    y: 74.29,
    width: 399.1,
    height: 39.21
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.62,19.93h11.08v-6.82h-9.43V5.47c-3.34,.05-6.63-.13-9.92,.5-4.45,.85-8.89,2.18-12.48,5.04-1.35,1.08-2.59,2.33-3.61,3.72-2.3,3.1-3.98,6.73-5.02,10.88-.82,3.63-1.23,8.04-1.23,13.24,0,5.47,1.45,10.69,4.36,15.69,2.94,5.05,7.43,8.89,13,10.71,4.17,1.36,8.43,1.32,12.76,1.5h23.37v-14.58s-26.03,0-26.09,0c-3.08-.08-4.66-1.27-5.97-2.79-1.74-2.04-2.09-3.54-2.26-6.35H53.5v-14.58H19.34c.93-5.68,4.69-8.51,11.28-8.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.91,
    y: 5.79,
    width: 10.05,
    height: 10.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.61,
    width: 9.1,
    height: 9.1
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "378.56 5.47 364.84 42.11 351.13 5.47 329.36 5.47 329.36 66.76 346.06 66.76 346.06 36.22 356.45 66.76 373.24 66.76 383.63 36.22 383.63 66.76 400.33 66.76 400.33 5.47 378.56 5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.98,5.47V39.74c0,9.13,3.28,11.51,9.92,11.51s10.01-1.94,10.01-11.51V5.47h16.93V38.75c0,18.61-9.73,28-27.42,28s-26.38-9.04-26.38-28.36V5.47h16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.35,66.66c0-4.54,0-10.08,0-14.63l34.25,.03c1.95,0,4.51,.31,6.11-.75,1.23-.81,1.57-1.56,1.57-2.99s-.8-2.85-2.08-3.58c-1.32-.75-2.94-.76-4.48-.74l-16.61,.21c-3.46,.04-7,.07-10.26-1.02-5.33-1.79-9.26-6.54-10.69-11.78-2.87-10.5,2.17-21.61,13.34-24.66,4.93-1.35,10.14-.98,15.27-.92,9.42,.11,18.84-.11,28.26,0,0,4.51,.01,10.02,.02,14.53h-34.89c-1.65,0-3.41,.03-4.76,.94-1.72,1.16-2.25,2.42-2.04,4.42,.11,1.09,.43,2.21,1.23,2.99,1.22,1.19,3.17,1.24,4.92,1.22l13.96-.2c5.47-.08,11.26-.08,15.95,2.62,3.3,1.9,5.74,5.02,7.06,8.48s1.59,7.24,1.14,10.91c-.41,3.34-1.46,6.71-3.72,9.28-2.37,2.69-5.87,4.27-9.45,5.02-3.58,.75-7.28,.74-10.95,.73l-33.13-.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.65,
    y: 5.47,
    width: 16.58,
    height: 61.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "206.53 5.47 206.53 20.17 226.35 20.17 226.35 66.76 242.93 66.76 242.93 20.17 262.75 20.17 262.75 5.47 206.53 5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.56,10.79c-2.3-2.01-5.16-3.31-8.17-4.11h.06c-3.11-1.06-9.17-1.21-9.17-1.21H59.94v61.29h16.58v-20.18h15.37c5.45,0,11.08,.2,15.67-2.47,5.95-3.47,8.38-11.76,8.33-18.44-.04-5.85-1.82-10.93-6.33-14.88Zm-13.55,20.98c-.95,.49-2.07,.57-3.15,.6-5.45,.15-10.91-.31-16.35,0v-12.19c5.3,0,10.6,0,15.9,0,1.21,0,2.47,.01,3.54,.55,2,1.01,2.63,3.48,2.6,5.65-.03,2.06-.66,4.39-2.55,5.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.2,105.35v1.14h-13.95v-25.2h13.55v1.13h-12.37v10.34h11.44v1.12h-11.44v11.46h12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.15,95.91h11.18v1.12h-11.18v-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.73,93.92c0-7.53,5.35-12.99,12.84-12.99,5.54,0,9.88,3.04,11.61,7.96h-1.22c-1.67-4.24-5.49-6.79-10.38-6.79-6.77,0-11.64,4.94-11.64,11.83s4.85,11.78,11.64,11.78c5.03,0,8.94-2.7,10.6-7.24h1.2c-1.7,5.22-6.12,8.4-11.8,8.4-7.51,0-12.84-5.41-12.84-12.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.42,93.92c0-7.4,5.42-13,12.99-13s12.99,5.58,12.99,13-5.42,12.95-12.99,12.95-12.99-5.58-12.99-12.95Zm24.79,0c0-6.76-4.92-11.84-11.8-11.84s-11.8,5.12-11.8,11.84,4.92,11.79,11.8,11.79,11.8-5.06,11.8-11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.63,97.2v-15.91h1.19v15.85c0,4.98,3.43,8.51,8.24,8.51s8.23-3.54,8.23-8.51v-15.85h1.19v15.91c0,5.6-3.98,9.61-9.42,9.61s-9.43-4.01-9.43-9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.77,95.5l6.58,10.99h-1.34l-6.53-10.93h-7.73v10.93h-1.18v-25.2h9.15c4.43,0,7.66,3,7.66,7.15,0,3.78-2.73,6.62-6.6,7.05Zm-9.03-1.08h7.93c3.82,0,6.51-2.52,6.51-5.98s-2.71-6.01-6.51-6.01h-7.93v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.06,99.08h1.2c0,3.97,3.05,6.54,7.64,6.54,4.18,0,7.12-2.39,7.12-5.92,0-4-3.54-4.76-7.31-5.6-3.92-.85-8.1-1.79-8.1-6.46,0-4.04,3.19-6.65,8.1-6.65s7.85,2.78,7.85,7.01h-1.17c0-3.56-2.69-5.87-6.7-5.87s-6.9,2.15-6.9,5.47c0,3.82,3.56,4.58,7.27,5.39,3.99,.89,8.16,1.84,8.16,6.7,0,4.28-3.46,7.09-8.32,7.09-5.31,0-8.85-3.05-8.85-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.65,105.35v1.14h-13.95v-25.2h13.55v1.13h-12.37v10.34h11.44v1.12h-11.44v11.46h12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.92,99.08h1.2c0,3.97,3.05,6.54,7.64,6.54,4.18,0,7.12-2.39,7.12-5.92,0-4-3.54-4.76-7.31-5.6-3.92-.85-8.1-1.79-8.1-6.46,0-4.04,3.19-6.65,8.1-6.65s7.85,2.78,7.85,7.01h-1.17c0-3.56-2.69-5.87-6.7-5.87s-6.9,2.15-6.9,5.47c0,3.82,3.56,4.58,7.27,5.39,3.99,.89,8.16,1.84,8.16,6.7,0,4.28-3.46,7.09-8.32,7.09-5.31,0-8.85-3.05-8.85-7.7Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoepistumEcourses);
export default __webpack_public_path__ + "static/media/logo epistum-ecourses.82ab47a9a53df2d01d481871de83a884.svg";
export { ForwardRef as ReactComponent };